import { connect } from 'react-redux';
import SetProfile from './SetProfile';
import { setUserProfile } from '../../actions/user';

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = dispatch => ({
  setUserProfile: info => dispatch(setUserProfile(info)),
});

const SetProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SetProfile);

export default SetProfileContainer;



// WEBPACK FOOTER //
// ./src/components/SetProfile/SetProfileContainer.js